<div style="padding-top: .5rem; margin-top: .5rem; border-top: 1px solid darkgrey; display: flex; flex-direction: column; gap: .5rem">
  <slot />
</div>
